var constant = require('./constant'),
    identity = require('./identity'),
    nativeDefineProperty = require('./_nativeDefineProperty');

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !nativeDefineProperty ? identity : function(func, string) {
  return nativeDefineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;



//////////////////
// WEBPACK FOOTER
// ./~/swagger-client/~/lodash/_baseSetToString.js
// module id = 1161
// module chunks = 0